import axios from '@/common/http.js';
function timeConvert(timestamp, num) {
    	//num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
    	timestamp = timestamp + '';
    	timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
    	var date = new Date(timestamp);
    	var y = date.getFullYear();
    	var m = date.getMonth() + 1;
    	m = m < 10 ? ('0' + m) : m;
    	var d = date.getDate();
    	d = d < 10 ? ('0' + d) : d;
    	var h = date.getHours();
    	h = h < 10 ? ('0' + h) : h;
    	var minute = date.getMinutes();
    	var second = date.getSeconds();
    	minute = minute < 10 ? ('0' + minute) : minute;
    	second = second < 10 ? ('0' + second) : second;
    	if (num == 0) {
    		return m + '-' + d + ' ' + h + ':' + minute;
    	}else if(num == 1){
    		return y + '-' + m + '-' + d
    	}else {
    		return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    	}
    }
var actions = {
	async getuserfilelist({commit,state},{schoolid,userid,pid,page=1,pagesize}={}){
		let {code,data,info} = await axios({
			url:'index/user.UserFile/getUserFile',
			method:'GET',
			params:{
				schoolid:schoolid || window.localStorage.getItem('schoolid'),//int	学校id	是	否		
				userid:userid || window.localStorage.getItem('userid'),//int	用户id	是	否		
				pid:pid || state.pid,//int	层级id	是	否		
				page:page || state.page,//int		是	否		
				pagesize:pagesize || state.pagesize,//
			}
		})
		if(code=='10001'){
			for(let i=0; i<data.length; i++){
				data[i].adtime = timeConvert(data[i].addtime)
				data[i].arr=[data[i]]
			}
			commit('setdedata',{
				data:data,
				key:'tabledata'
			})
			commit('setdedata',{
				data:info || 0,
				key:'total'
			})
		}else{
			commit('setdedata',{
				data:[],
				key:'tabledata'
			})
			commit('setdedata',{
				data:0,
				key:'total'
			})
		}
		if(page!=undefined){
			commit('setData',{
				data:page,
				field:"page"
			})
		}
	},
}
export default actions
	


// WEBPACK FOOTER //
// ./src/store/modules/personal/action.js